const VISIBLE_CLASS = 'anim_visible';
const LOAD_CLASS = 'anim_load';
const GROUP_CLASS = 'anim-group';

export default function animations() {

    const items = document.querySelectorAll('.anim, .anim-group');

    if (items.length === 0) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || !('IntersectionObserver' in window)) {
        items.forEach(clean);
        return;
    }

    const onLoad = [];
    const onScroll = [];

    items.forEach(item => {
        if (item.classList.contains(LOAD_CLASS)) {
            onLoad.push(item);
        } else {
            onScroll.push(item);
        }
    });

    // Два кадра, чтобы браузер успел отрисовать скрытое состояние и проиграл переход
    requestAnimationFrame(() => {
        requestAnimationFrame(() => onLoad.forEach(reveal));
    });

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;

            reveal(entry.target);
            observer.unobserve(entry.target);
        });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0 });

    onScroll.forEach(item => observer.observe(item));

    function reveal(item) {
        item.classList.add(VISIBLE_CLASS);
        setTimeout(() => clean(item), totalDuration(item));
    }

}

// Классы снимаются после показа, чтобы transition анимаций не перебивал
// собственные переходы элемента — например подсветку карточки при наведении
function clean(item) {
    item.classList.remove('anim', GROUP_CLASS, VISIBLE_CLASS);
}

function totalDuration(item) {
    const styles = getComputedStyle(
        item.classList.contains(GROUP_CLASS)
            ? (item.querySelector(':scope > *:not(.anim-skip)') || item)
            : item
    );
    const duration = toMs(styles.getPropertyValue('--anim-duration'), 700);
    const delay = toMs(styles.getPropertyValue('--anim-delay'), 0);
    const step = toMs(styles.getPropertyValue('--anim-step'), 100);
    const steps = item.classList.contains(GROUP_CLASS) ? Math.max(item.children.length - 1, 0) : 0;

    // Для группы берём задержку первого ребёнка и прибавляем stagger остальных
    return duration + delay + step * steps + 100;
}

function toMs(value, fallback) {
    const parsed = parseFloat(value);

    if (Number.isNaN(parsed)) return fallback;

    return value.trim().endsWith('ms') ? parsed : parsed * 1000;
}
